export default __webpack_public_path__ + "static/media/resendEmail.9926e1fc.svg";